/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OtherCostRowData } from './OtherCostRowData';
import {
    OtherCostRowDataFromJSON,
    OtherCostRowDataFromJSONTyped,
    OtherCostRowDataToJSON,
    OtherCostRowDataToJSONTyped,
} from './OtherCostRowData';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface OtherCostsData
 */
export interface OtherCostsData {
    /**
     * 
     * @type {number}
     * @memberof OtherCostsData
     */
    sourceCount?: number;
    /**
     * 
     * @type {number}
     * @memberof OtherCostsData
     */
    recordCount?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof OtherCostsData
     */
    allocatedSpend?: MoneyOutput;
    /**
     * 
     * @type {Array<OtherCostRowData>}
     * @memberof OtherCostsData
     */
    rows?: Array<OtherCostRowData>;
}

/**
 * Check if a given object implements the OtherCostsData interface.
 */
export function instanceOfOtherCostsData(value: object): value is OtherCostsData {
    return true;
}

export function OtherCostsDataFromJSON(json: any): OtherCostsData {
    return OtherCostsDataFromJSONTyped(json, false);
}

export function OtherCostsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtherCostsData {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceCount': json['sourceCount'] == null ? undefined : json['sourceCount'],
        'recordCount': json['recordCount'] == null ? undefined : json['recordCount'],
        'allocatedSpend': json['allocatedSpend'] == null ? undefined : MoneyOutputFromJSON(json['allocatedSpend']),
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(OtherCostRowDataFromJSON)),
    };
}

export function OtherCostsDataToJSON(json: any): OtherCostsData {
    return OtherCostsDataToJSONTyped(json, false);
}

export function OtherCostsDataToJSONTyped(value?: OtherCostsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceCount': value['sourceCount'],
        'recordCount': value['recordCount'],
        'allocatedSpend': MoneyOutputToJSON(value['allocatedSpend']),
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(OtherCostRowDataToJSON)),
    };
}

